import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import { useFinancialsGridSettings } from './FinancialsSettingsState';

export function FinancialsGridNoRowsOverlay() {
  const {
    displaySettings: { reportedOnly },
    handleSettingsChange,
  } = useFinancialsGridSettings();

  if (!reportedOnly) {
    return null;
  }
  return (
    <div style={{ backgroundColor: 'transparent', border: 'none' }}>
      <Button
        size='large'
        variant='contained'
        color='secondary'
        startIcon={<AddIcon />}
        onClick={() => handleSettingsChange('reportedOnly')}
      >
        Add Financials and KPIs
      </Button>
    </div>
  );
}
